const accordionElements = document.body.querySelectorAll('.accordion')

Array.from(accordionElements).forEach((accordionElement) => {
    const isOpen = accordionElement.classList.contains('accordion--open')
    
    const accordionButtonElement = accordionElement.querySelector('.accordion__button')

    const accordionContentElement = accordionElement.querySelector('.accordion__content')
    accordionContentElement.style.maxHeight = `${isOpen ? accordionContentElement.scrollHeight : 0}px`

    accordionButtonElement.addEventListener('click', () => {
        accordionElement.classList.toggle('accordion--open')

        const isOpen = accordionElement.classList.contains('accordion--open')
        accordionContentElement.style.maxHeight = `${isOpen ? accordionContentElement.scrollHeight : 0}px`
    }) 
})
